// Gets the domain from the provided URL
function getDomain(url) {
  try {
    const { hostname } = new URL(url);
    return hostname;
  } catch {
    return null;
  }
}

// Shows the leave site notice, using the provided anchor
function showLeaveSiteNotice(speedbump: any, url: string | URL, target: string, isEmail: boolean): void {
  let modal = document.getElementById(speedbump.modalId) as HTMLDivElement;
  if (!modal) {
    console.error('Cannot find speedbump modal with id', speedbump.modalId);
    return;
  }

  let continueButton = modal.getElementsByClassName('btn-continue')[0] as HTMLButtonElement;
  if (!continueButton) {
    console.error('Cannot find continue button with class', 'btn-continue');
    return;
  }
  
  let triggerButton = document.getElementById(speedbump.triggerId) as HTMLButtonElement;
  if (!triggerButton) {
    console.error('Cannot find trigger button with id', speedbump.triggerId);
    return;
  }

  continueButton.setAttribute('href', url.toString());
  continueButton.setAttribute('target', target);

  if (isEmail) {
    modal.classList.add('email-speedbump-modal');
  } else {
    modal.classList.remove('email-speedbump-modal');
  }

  triggerButton.click();
}

// Add click event for page anchors
function registerLeavingSiteNoticeEvents()
{
  if (window['wf'] && window['wf']['speedbumps']) {
    const speedbumps = window['wf']['speedbumps'];
    speedbumps.forEach((speedbump: any) => {
      document.querySelectorAll<HTMLAnchorElement>("a[href^=http], a[href^=mailto]").forEach(anchor => {
        let linkHref = anchor.getAttribute('href') || '';
        let isEmail = linkHref.toLowerCase().startsWith("mailto:");
        let domain = getDomain(isEmail ? `https://${linkHref.split('@')[1]}` : linkHref);
        let isExternal = domain && domain.indexOf(location.hostname) === -1;
        let bumpIt = isExternal && isEmail ? speedbump.emailSpeedbump && !speedbump.excludedEmails.includes(domain) : !speedbump.excludedDomains.includes(domain);
        if (bumpIt) {
          anchor.addEventListener('click', (e) => {
            e.preventDefault();
            showLeaveSiteNotice(speedbump, anchor.getAttribute('href') ?? '', anchor.getAttribute('target') ?? "_blank", isEmail);
          });
        }
      });

      // Intercept window.open to process external links
      const originalWindowOpen = window.open;
      const interceptWindowOpen = function(url?: string | URL, target?: string, features?: string) {
        let domain = getDomain(url);
        let isExternal = domain && domain.indexOf(location.hostname) === -1;
        if (isExternal && !speedbump.excludedDomains.includes(domain)) {
          showLeaveSiteNotice(speedbump, url ?? '', '_blank', false);
          return null;
        } else {
          return originalWindowOpen(url, target, features);
        }
      }
      window.open = interceptWindowOpen;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  registerLeavingSiteNoticeEvents();
});